import type { ReactNode } from 'react';
import { useEffect, useRef, useState } from 'react';
import { Text } from '@querodelivery/uni-react';
import styles from './table-empty-state.module.scss';
import EmptyStateIcon from '../../Assets/svg/empty-directory.svg';

type TableEmptyStateProps = {
  title: string;
  description?: string;
  action?: ReactNode;
};

const MIN_HEIGHT = 320;
const BOTTOM_SPACING = 32;

export function TableEmptyState({
  title,
  description,
  action,
}: TableEmptyStateProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [minHeight, setMinHeight] = useState(MIN_HEIGHT);

  useEffect(() => {
    function updateMinHeight() {
      if (!containerRef.current) return;

      const { top } = containerRef.current.getBoundingClientRect();
      const availableHeight = window.innerHeight - top - BOTTOM_SPACING;

      setMinHeight(Math.max(availableHeight, MIN_HEIGHT));
    }

    updateMinHeight();

    window.addEventListener('resize', updateMinHeight);

    return () => window.removeEventListener('resize', updateMinHeight);
  }, []);

  return (
    <div ref={containerRef} className={styles.container} style={{ minHeight }}>
      <div className={styles.content}>
        <div className={styles.iconContainer}>
          <img src={EmptyStateIcon} alt="Empty state" width={100} />
        </div>

        <Text variant="headingMd" tone="supporting" fontWeight="bold">
          {title}
        </Text>

        {description ? (
          <Text variant="bodyMd" tone="supporting">
            {description}
          </Text>
        ) : null}

        {action}
      </div>
    </div>
  );
}
